import {base64ToBytes} from './base64-to-bytes';
import {IV_LENGTH, CIPHER_PREFIX} from './cipher-format';
import {isCipher} from './is-cipher';

/**
 * @returns the decrypted payload, or `undefined` when `cipher` was not written by `encrypt` with this `key`
 */
export const decrypt = async (cipher: unknown, key: CryptoKey): Promise<any> => {
    if (!isCipher(cipher)) {
        return undefined;
    }

    try {
        const bytes = base64ToBytes(cipher.slice(CIPHER_PREFIX.length));
        const plaintext = await crypto.subtle.decrypt(
            {name: 'AES-GCM', iv: bytes.subarray(0, IV_LENGTH)},
            key,
            bytes.subarray(IV_LENGTH),
        );
        return JSON.parse(new TextDecoder().decode(plaintext));
    } catch {
        return undefined;
    }
};
